import { render, staticRenderFns } from "./GuiaRemisionTransportistaConsulta.vue?vue&type=template&id=6451c860&scoped=true&"
import script from "./GuiaRemisionTransportistaConsulta.vue?vue&type=script&lang=js&"
export * from "./GuiaRemisionTransportistaConsulta.vue?vue&type=script&lang=js&"
import style0 from "./GuiaRemisionTransportistaConsulta.vue?vue&type=style&index=0&id=6451c860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6451c860",
  null
  
)

export default component.exports